import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-thinking',
  templateUrl: './ai-thinking.component.html',
  styleUrls: ['./ai-thinking.component.css']
})
export class AiThinkingComponent {}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/components/ai-thinking/ai-thinking.component.ts